import React from "react";
import Notes from "./Notes";

const NoteCard = (props) => {
  const { showAlert } = props;
  return (
    <div>
      <h1 id="NotesHeader">Your Notes</h1>
      <Notes showAlert={showAlert}/>
    </div>
  );
};

export default NoteCard;
